export const whilelistedKeys = [
	'resource_deployment_environment',
	'resource_deployment.environment',
	'resource_k8s_cluster_name',
	'resource_k8s.cluster.name',
	'resource_k8s_cluster_namespace',
	'resource_k8s.cluster.namespace',
];
